import "bootstrap";
import "slick-carousel";
import AOS from "aos";
import BigPicture from "bigpicture";
import "bootstrap-select";
import "bootstrap-select/dist/css/bootstrap-select.min.css";
import Cookies from "js-cookie";
import "./resources_search";

(function ($) {
  // close mobile menu on window resize
  window.onresize = function () {
    $(".menu-open").removeClass("is-active");
    $("header").removeClass("active");
    $(".mobile-menu-wrapper").removeClass("active");
    $("body").removeClass("menu-open");
  };

  // On Dom Ready
  $(function () {
    AOS.init({
      once: false,
      offset: 120,
      duration: 700,
    });

    // Mobile menu button
    $(".menu-open").on("click", function (e) {
      e.preventDefault();
      $(this).toggleClass("is-active");
      $("header").toggleClass("active");
      $(".mobile-menu-wrapper").toggleClass("active");
      $("body").toggleClass("menu-open");
    });

    function close_menu() {
      $(this).removeClass("is-active");
      $("header").removeClass("active");
      $(".mobile-menu-wrapper").removeClass("active");
      $("body").removeClass("menu-open");
    }

    // Mobile menu submenu toggle
    $(".mobile-menu-wrapper ul.mobile-menu li.menu-item-has-children > span.icon-down, .mobile-menu-wrapper ul.mobile-menu li.no-link > a").on("click", function (e) {
      e.preventDefault();
      $(this).parent().toggleClass("active");
      $(this).parent().find(".sub-menu:first").stop().slideToggle();
    });

    // Search form toggle
    $("header .header-content-right #searchform .btn-search").on("click", function (e) {
      if (!$("header .header-content-right #searchform").hasClass("active")) {
        e.preventDefault();
        $("header .header-content-right #searchform").addClass("active");
        $("header .header-content-right #searchform #s").focus();
      }
    });

    // Mega menu toggle
    $("header .header-content-right ul.main-menu > li.menu-item-has-children > a").on("click", function (e) {
      e.preventDefault();

      $("header .header-content-right ul.main-menu > li.menu-item-has-children > a").not(this).parent().removeClass("active");
      if ($(this).parent().hasClass("active")) {
        $(this).parent().removeClass("active");
        $(".body-overlay").removeClass("active");
        $("body").removeClass("mega-menu-active");

        const body = document.body;
        const scrollY = body.style.top;
        body.style.position = "";
        body.style.top = "";
        window.scrollTo(0, parseInt(scrollY || "0") * -1);
      } else {
        $(this).parent().addClass("active");
        $(".body-overlay").addClass("active");
        $("body").addClass("mega-menu-active");

        const scrollY = document.documentElement.style.getPropertyValue("--scroll-y");
        const body = document.body;
        body.style.position = "fixed";
        body.style.top = `-${scrollY}`;
      }
    });
    $(".mega-menu .megamenu-close").on("click", function (e) {
      e.preventDefault();
      $("header .header-content-right ul.main-menu > li.menu-item-has-children").removeClass("active");
      $(".body-overlay").removeClass("active");
      $("body").removeClass("mega-menu-active");

      const body = document.body;
      const scrollY = body.style.top;
      body.style.position = "";
      body.style.top = "";
      window.scrollTo(0, parseInt(scrollY || "0") * -1);
    });

    window.addEventListener("scroll", () => {
      document.documentElement.style.setProperty("--scroll-y", `${window.scrollY}px`);
    });

    // Mega Menu: Top Caption Change on Hover
    $(".megamenu1-content > .sub-menu > li > a").hover(
      function () {
        console.log("hovered");
        var topCaption = $(this).data("text");
        if (topCaption) {
          console.log("topCaption: " + topCaption);
          $(this).closest(".mega-menu-1").find(".megamenu1-top-caption").text(topCaption);
        }
      },
      function () {
        var originalCaption = $(this).closest(".mega-menu-1").find(".megamenu1-top-caption").data("original");
        $(this).closest(".mega-menu-1").find(".megamenu1-top-caption").text(originalCaption);
      }
    );

    // Footer Find a Rep
    $(".find-a-rep-footer").on("change", function () {
      var url = $(this).val();
      if (url) {
        window.location = url;
      }
      return false;
    });

    // Hide search form when clicked outside
    $(document).on("click", function (e) {
      var $target = $(e.target);

      if (!$target.closest("#searchform").length) {
        $("header .header-content-right #searchform").removeClass("active");
      }

      if (!$target.closest(".mobile-menu-wrapper").length && !$target.closest("header .menu-open").length) {
        close_menu();
      }
    });

    // Video Links to call BigPicture
    $(".video-link").on("click", function (e) {
      e.preventDefault();
      var ytsrc = $(this).data("ytsrc");
      var vimeosrc = $(this).data("vimeosrc");

      var options = {
        el: e.target,
      };
      if (ytsrc) {
        options.ytSrc = ytsrc;
      }
      if (vimeosrc) {
        options.vimeoSrc = vimeosrc;
      }

      BigPicture(options);
    });

    // featured content carousel
    $(".featured-content-block .the-carousel, .full-width-blog-content .the-carousel").each(function (index, element) {
      var slider = $(this);
      var prevBtn = $(this).parent().parent().find(".prev");
      var nextBtn = $(this).parent().parent().find(".next");
      var counterElement = $(this).parent().parent().find(".carousel-nav .page-numbers .count");

      slider.on("init reInit afterChange", function (event, slick, currentSlide, nextSlide) {
        var slidesToShow = slick.options.slidesToShow;

        var totalSlides = Math.ceil(slick.slideCount / slidesToShow);

        if (!currentSlide) {
          currentSlide = slidesToShow;
        } else {
          currentSlide = currentSlide + slidesToShow;
        }
        currentSlide = currentSlide / slidesToShow;

        //var i = (currentSlide ? currentSlide : 0) + 1;
        //counterElement.text(leftFillNum(i, 2) + "/" + leftFillNum(slick.slideCount, 2));
        counterElement.text(leftFillNum(currentSlide, 2) + "/" + leftFillNum(totalSlides, 2));

        // Hide nav if there is only one slide
        if (totalSlides <= 1) {
          $(this).parent().parent().find(".carousel-nav").hide();
        } else {
          $(this).parent().parent().find(".carousel-nav").show();
        }
      });

      slider.slick({
        autoplay: false,
        autoplaySpeed: 3000,
        dots: false,
        arrows: true,
        infinite: true,
        speed: 700,
        slidesToShow: 4,
        slidesToScroll: 4,
        adaptiveHeight: false,
        rows: 0,
        prevArrow: prevBtn,
        nextArrow: nextBtn,
        responsive: [
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            },
          },
          {
            breakpoint: 579,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    });

    // portfolio block carousel - xl
    $(".portfolio-block .the-carousel.carousel-xl, .onethird-image-block .the-carousel, .fifty-fifty-quad-portfolio-block .the-carousel").each(function (index, element) {
      var slider = $(this);
      var counterElement;

      if ($("body").hasClass("page-template-portfolio-landing")) {
        counterElement = $(".pagination-links--portfolio-landing.pagination-links--xl .page-numbers .count");
        var prevBtn = $(this).parent().parent().find(".pagination-links--xl .prev");
        var nextBtn = $(this).parent().parent().find(".pagination-links--xl .next");
      } else {
        counterElement = $(this).parent().find(".carousel-nav .page-numbers .count");
        var prevBtn = $(this).parent().find(".prev");
        var nextBtn = $(this).parent().find(".next");
      }

      slider.on("init reInit afterChange", function (event, slick, currentSlide, nextSlide) {
        var i = (currentSlide ? currentSlide : 0) + 1;
        counterElement.text(leftFillNum(i, 2) + "/" + leftFillNum(slick.slideCount, 2));
      });
      slider.slick({
        autoplay: false,
        autoplaySpeed: 3000,
        dots: false,
        arrows: true,
        infinite: true,
        speed: 700,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: false,
        rows: 0,
        prevArrow: prevBtn,
        nextArrow: nextBtn,
      });
    });

    $(".portfolio-block .the-carousel.carousel-sm").each(function (index, element) {
      var slider = $(this);
      var counterElement;

      if ($("body").hasClass("page-template-portfolio-landing")) {
        counterElement = $(".pagination-links--portfolio-landing.pagination-links--sm .page-numbers .count");
        var prevBtn = $(this).parent().parent().find(".pagination-links--sm .prev");
        var nextBtn = $(this).parent().parent().find(".pagination-links--sm .next");
      } else {
        counterElement = $(this).parent().find(".carousel-nav .page-numbers .count");
        var prevBtn = $(this).parent().find(".prev");
        var nextBtn = $(this).parent().find(".next");
      }

      slider.on("init reInit afterChange", function (event, slick, currentSlide, nextSlide) {
        var i = (currentSlide ? currentSlide : 0) + 1;
        counterElement.text(leftFillNum(i, 2) + "/" + leftFillNum(slick.slideCount, 2));
      });
      slider.slick({
        autoplay: false,
        autoplaySpeed: 3000,
        dots: false,
        arrows: true,
        infinite: true,
        speed: 700,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: false,
        rows: 0,
        prevArrow: prevBtn,
        nextArrow: nextBtn,
      });
    });

    // portfolio block carousel - mobile
    $(".portfolio-block .the-carousel.mobile-carousel").each(function (index, element) {
      var slider = $(this);
      var prevBtn = $(this).parent().find(".prev");
      var nextBtn = $(this).parent().find(".next");
      var counterElement = $(this).parent().find(".carousel-nav .page-numbers .count");
      slider.on("init reInit afterChange", function (event, slick, currentSlide, nextSlide) {
        var i = (currentSlide ? currentSlide : 0) + 1;
        counterElement.text(leftFillNum(i, 2) + "/" + leftFillNum(slick.slideCount, 2));
      });
      slider.slick({
        autoplay: false,
        autoplaySpeed: 3000,
        dots: false,
        arrows: true,
        infinite: true,
        speed: 700,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: false,
        rows: 0,
        prevArrow: prevBtn,
        nextArrow: nextBtn,

        responsive: [
          {
            breakpoint: 1025,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            },
          },
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
          {
            breakpoint: 579,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    });

    $(".line-art-carousel").each(function (index, element) {
      let slider = $(this);
      let navWrap = $(this).parent().find(".carousel-nav");
      let prevBtn = $(this).parent().find(".prev");
      let nextBtn = $(this).parent().find(".next");
      let counterElement = $(this).parent().find(".carousel-nav .page-numbers .count");
      slider.on("init reInit afterChange", function (event, slick, currentSlide, nextSlide) {
        let slidesToShow = slick.options.slidesToShow;
        let totalSlides = Math.ceil(slick.slideCount / slidesToShow);
        if (!currentSlide) {
          currentSlide = slidesToShow;
        } else {
          currentSlide = currentSlide + slidesToShow;
        }
        currentSlide = currentSlide / slidesToShow;
        counterElement.text(leftFillNum(currentSlide, 2) + "/" + leftFillNum(totalSlides, 2));
      });
      slider.slick({
        autoplay: false,
        autoplaySpeed: 3000,
        dots: false,
        arrows: true,
        infinite: false,
        speed: 700,
        adaptiveHeight: false,
        rows: 0,
        appendArrows: navWrap,
        prevArrow: prevBtn,
        nextArrow: nextBtn,
        responsive: [
          {
            breakpoint: 1280,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4,
            },
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            },
          },
          {
            breakpoint: 740,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    });

    $(".detail-slider-wrap").each(function (index, element) {
      let imgSlider = $(this).find(".detail-slider");
      let captionSlider = $(this).find(".detail-caption-slider");
      let prevBtn = $(this).find(".prev");
      let nextBtn = $(this).find(".next");

      // Ensure we always have at least six slides so that infinite mode works
      // See https://github.com/akiran/react-slick/issues/1813
      if ($(".the-slide", imgSlider).length < 6) {
        while ($(".the-slide", imgSlider).length < 6) {
          $(".the-slide", imgSlider).clone().appendTo(imgSlider);
          $(".the-slide", captionSlider).clone().appendTo(captionSlider);
        }
      }

      imgSlider.slick({
        autoplay: false,
        autoplaySpeed: 3000,
        dots: false,
        arrows: true,
        infinite: true,
        speed: 700,
        adaptiveHeight: false,
        slidesToShow: 3,
        variableWidth: false,
        rows: 0,
        prevArrow: prevBtn,
        nextArrow: nextBtn,
        responsive: [
          {
            breakpoint: 900,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              variableWidth: false,
              infinite: true,
            },
          },
          {
            breakpoint: 760,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              variableWidth: false,
              infinite: true,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              variableWidth: false,
              infinite: true,
            },
          },
        ],
      });

      captionSlider.slick({
        autoplay: false,
        autoplaySpeed: 3000,
        dots: false,
        arrows: false,
        infinite: false,
        speed: 700,
        adaptiveHeight: false,
        slidesToShow: 1,
        rows: 0,
        fade: true,
        responsive: [
          {
            breakpoint: 900,
            settings: {
              infinite: true,
            },
          },
        ],
      });

      // Sync imgSlider and captionSlider
      // note: the 'asNavFor' feature should have worked well here, but it didn't. see issue #8398
      imgSlider.on("afterChange", function (slick, currentSlide) {
        var currentSlideIndex = imgSlider.slick("slickCurrentSlide");
        captionSlider.slick("slickGoTo", currentSlideIndex);
      });
    });

    $(".basic-gallery-slider").each(function (index, element) {
      let imgSlider = $(this).find(".basic-gallery-image-slider");
      let captionSlider = $(this).find(".basic-gallery-caption-slider");

      var prevBtn = $(this).find(".prev");
      var nextBtn = $(this).find(".next");
      var counterElement = $(this).find(".carousel-nav .page-numbers .count");
      imgSlider.on("init reInit afterChange", function (event, slick, currentSlide, nextSlide) {
        var slidesToShow = slick.options.slidesToShow;

        var totalSlides = Math.ceil(slick.slideCount / slidesToShow);

        if (!currentSlide) {
          currentSlide = slidesToShow;
        } else {
          currentSlide = currentSlide + slidesToShow;
        }
        currentSlide = currentSlide / slidesToShow;

        //var i = (currentSlide ? currentSlide : 0) + 1;
        //counterElement.text(leftFillNum(i, 2) + "/" + leftFillNum(slick.slideCount, 2));
        counterElement.text(leftFillNum(currentSlide, 2) + "/" + leftFillNum(totalSlides, 2));
      });

      imgSlider.slick({
        autoplay: false,
        autoplaySpeed: 3000,
        dots: false,
        arrows: true,
        infinite: true,
        speed: 700,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: false,
        rows: 0,
        asNavFor: captionSlider,
        prevArrow: prevBtn,
        nextArrow: nextBtn,
      });

      captionSlider.slick({
        autoplay: false,
        autoplaySpeed: 3000,
        dots: false,
        arrows: false,
        infinite: true,
        speed: 700,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: false,
        rows: 0,
        asNavFor: imgSlider,
        fade: true,
      });
    });

    // 50/50 Copy Block Slider
    $(".fifty-fifty-gallery-slider").each(function (index, element) {
      let imgSlider = $(this).find(".fifty-fifty-gallery-image-slider");
      var prevBtn = $(this).find(".prev");
      var nextBtn = $(this).find(".next");
      var counterElement = $(this).find(".carousel-nav .page-numbers .count");
      imgSlider.on("init reInit afterChange", function (event, slick, currentSlide, nextSlide) {
        var slidesToShow = slick.options.slidesToShow;

        var totalSlides = Math.ceil(slick.slideCount / slidesToShow);

        if (!currentSlide) {
          currentSlide = slidesToShow;
        } else {
          currentSlide = currentSlide + slidesToShow;
        }
        currentSlide = currentSlide / slidesToShow;

        counterElement.text(leftFillNum(currentSlide, 2) + "/" + leftFillNum(totalSlides, 2));
      });

      imgSlider.slick({
        autoplay: false,
        autoplaySpeed: 3000,
        dots: false,
        arrows: true,
        infinite: true,
        speed: 700,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: false,
        rows: 0,
        prevArrow: prevBtn,
        nextArrow: nextBtn,
      });
    });

    // Module: Slideshow with Hotspots
    $(".slideshow-with-hotspots-slider").each(function (index, element) {
      let imgSlider = $(this).find(".slideshow-with-hotspots-image-slider");

      var prevBtn = $(this).find(".prev");
      var nextBtn = $(this).find(".next");
      var counterElement = $(this).find(".carousel-nav .page-numbers .count");
      imgSlider.on("init reInit afterChange", function (event, slick, currentSlide, nextSlide) {
        var slidesToShow = slick.options.slidesToShow;

        var totalSlides = Math.ceil(slick.slideCount / slidesToShow);

        if (!currentSlide) {
          currentSlide = slidesToShow;
        } else {
          currentSlide = currentSlide + slidesToShow;
        }
        currentSlide = currentSlide / slidesToShow;

        counterElement.text(leftFillNum(currentSlide, 2) + "/" + leftFillNum(totalSlides, 2));
      });

      // Mobile: show first tooltips on load
      $(imgSlider).on("init", function (event, slick) {
        $(".tooltip-mobile-wrapper").removeClass("show");
        $("#tooltip-mobile-1").addClass("show");
      });

      imgSlider.slick({
        autoplay: false,
        autoplaySpeed: 3000,
        dots: false,
        arrows: true,
        infinite: true,
        fade: true,
        cssEase: "linear",
        speed: 700,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: false,
        rows: 0,
        prevArrow: prevBtn,
        nextArrow: nextBtn,
      });

      // Desktop: tooltip click behavior
      $(".tooltip-toggle", imgSlider).on("click", function (e) {
        e.preventDefault();
        var $this = $(this).parent(".tooltip-wrapper");
        $(".tooltip-wrapper", imgSlider).not($this).removeClass("open"); // close other tooltips
        $this.toggleClass("open"); // open this tooltip
        $(".tooltip-wrapper", imgSlider).not($this).find(".tooltip-content").slideUp(); // close other tooltips
        $this.find(".tooltip-content").stop().slideToggle(); // open this tooltip
      });

      // Desktop: show first tooltip on load
      $(".slideshow-with-hotspots-image-slider .the-thumb .tooltip-toggle").first().trigger("click");

      // Mobile: show mobile tooltips on slide change
      $(imgSlider).on("afterChange", function (event, slick, currentSlide) {
        $(".tooltip-mobile-wrapper").removeClass("show");
        $("#tooltip-mobile-" + (currentSlide + 1)).addClass("show");
      });
    });

    // timeline carousel
    $(".the-event__media .media__slideshow .the-carousel").each(function (index, element) {
      var slider = $(this);
      var prevBtn = $(this).parent().parent().find(".prev");
      var nextBtn = $(this).parent().parent().find(".next");
      var counterElement = $(this).parent().parent().find(".carousel-nav .page-numbers .count");

      slider.on("init reInit afterChange", function (event, slick, currentSlide, nextSlide) {
        var slidesToShow = slick.options.slidesToShow;

        var totalSlides = Math.ceil(slick.slideCount / slidesToShow);

        if (!currentSlide) {
          currentSlide = slidesToShow;
        } else {
          currentSlide = currentSlide + slidesToShow;
        }
        currentSlide = currentSlide / slidesToShow;

        //var i = (currentSlide ? currentSlide : 0) + 1;
        //counterElement.text(leftFillNum(i, 2) + "/" + leftFillNum(slick.slideCount, 2));
        counterElement.text(leftFillNum(currentSlide, 2) + "/" + leftFillNum(totalSlides, 2));

        // Hide nav if there is only one slide
        if (totalSlides <= 1) {
          $(this).parent().parent().find(".carousel-nav").hide();
        } else {
          $(this).parent().parent().find(".carousel-nav").show();
        }
      });

      slider.slick({
        autoplay: false,
        autoplaySpeed: 3000,
        dots: false,
        arrows: true,
        infinite: true,
        speed: 700,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        rows: 0,
        prevArrow: prevBtn,
        nextArrow: nextBtn,
      });
    });

    function heroSliderInit() {
      $(".hero-slider").each(function (index, element) {
        let imgSlider = $(this).find(".hero-images-slider");
        let captionSlider = $(this).find(".basic-gallery-caption-slider");

        var prevBtn = $(this).find(".prev");
        var nextBtn = $(this).find(".next");
        var counterElement = $(this).find(".carousel-nav .page-numbers .count");

        imgSlider.on("init", function (event, slick, currentSlide, nextSlide) {
          imgSlider.fadeTo(250, 1);
        });

        imgSlider.on("init reInit afterChange", function (event, slick, currentSlide, nextSlide) {
          var slidesToShow = slick.options.slidesToShow;

          var totalSlides = Math.ceil(slick.slideCount / slidesToShow);

          if (!currentSlide) {
            currentSlide = slidesToShow;
          } else {
            currentSlide = currentSlide + slidesToShow;
          }
          currentSlide = currentSlide / slidesToShow;

          //var i = (currentSlide ? currentSlide : 0) + 1;
          //counterElement.text(leftFillNum(i, 2) + "/" + leftFillNum(slick.slideCount, 2));
          counterElement.text(leftFillNum(currentSlide, 2) + "/" + leftFillNum(totalSlides, 2));
        });
        
        if( imgSlider.closest('.portfolio-grid').length ){
          imgSlider.on("afterChange", function (event, slick, currentSlide, nextSlide) {
            var projectSliderId = $(this).closest('.modal').attr('id');
            var hashSlide = parseInt(currentSlide) + 1; // make current slide in hash 1-based
            if( !!(window.history && window.history.replaceState) && projectSliderId ){
              history.replaceState( {}, '', '#' + projectSliderId + '--' + hashSlide.toString() );
            }
          });
        }

        let asCSNav = null;

        if (captionSlider.length) {
          asCSNav = captionSlider;
        }

        imgSlider.slick({
          autoplay: false,
          dots: false,
          arrows: true,
          infinite: true,
          speed: 700,
          slidesToShow: 1,
          slidesToScroll: 1,
          adaptiveHeight: false,
          rows: 0,
          asNavFor: asCSNav,
          prevArrow: prevBtn,
          nextArrow: nextBtn,
        });

        if (captionSlider.length) {
          captionSlider.slick({
            autoplay: false,
            dots: false,
            arrows: false,
            infinite: true,
            speed: 700,
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: false,
            rows: 0,
            asNavFor: imgSlider,
            fade: true,
          });
        }
      });
    }

    heroSliderInit();

    // Modal Slider Shown
    $("#portfolio-data, .portfolio-block-modals").on("shown.bs.modal", ".modal-project-slider", function (event) {
      // sliders are hidden via 0 opaicty to prevent user from seeing ugliness before images are loaded
      $(this).find(".hero-images-slider").fadeTo(250, 1).slick("setPosition").slick("slickGoTo", 0, true);
      $(this).find(".basic-gallery-caption-slider").fadeTo(250, 1).slick("setPosition");
    });
    // Modal Slider Hidden
    $("#portfolio-data, .portfolio-block-modals").on("hidden.bs.modal", ".modal-project-slider", function (event) {
      // hide sliders again to prevent user from seeing ugliness before images are loaded
      $(this).find(".hero-images-slider").css("opacity", 0).slick("slickGoTo", 0, true);
      $(this).find(".basic-gallery-caption-slider").css("opacity", 0);
      if( !!(window.history && window.history.replaceState) ){
        history.replaceState( {}, '', window.location.pathname + window.location.search ); // remove hash
      }
    });
		
    $("#portfolio-data, .portfolio-block-modals").on('click', 'a.the-project', function(event) {
      var href = $(this).attr('href');
      if( !!(window.history && window.history.replaceState) ){
        history.replaceState( {}, '', href );
      }
    });
    
    /* Open a bootstrap modal on load and optionally advanced to a specific slide
     * Hash format is #modalid--slidenum, for example #project-slider-17637--3 to open modal 17637 and advance to slide 3
    */
    function directLinkModal(hash) {
      var hash = window.location.hash;
      var targetModal = hash;
      var targetSlide = '';
      
      if( hash !== '' && hash.indexOf('--') ){
        var hashParts = hash.split('--');
        targetModal = hashParts[0];
        targetSlide = hashParts[1];
      }
      
      if( $(targetModal).length && $(targetModal).hasClass('modal') ){
        $(targetModal).modal('show');
        $('.slick-slider', targetModal).slick('slickGoTo', parseInt(targetSlide) - 1);
      }
    }

    $(window).on('load', function () {
      directLinkModal();
    });

    $(".quad-img-box, .takeover-box").hover(
      function () {
        let overlayIdx = $(this).data("overlay");
        $(this)
          .closest(".the-slide")
          .find(".overlay-" + overlayIdx)
          .addClass("active-overlay");
      },
      function () {
        $(this).closest(".the-slide").find(".overlay").removeClass("active-overlay");
      }
    );

    $(".icon-ribbon-carousel-wrap .the-carousel").each(function (index, element) {
      var slider = $(this);
      var prevBtn = $(this).closest(".icon-ribbon-block").find(".prev");
      var nextBtn = $(this).closest(".icon-ribbon-block").find(".next");
      var interval;

      slider.slick({
        autoplay: true,
        autoplaySpeed: 3000,
        dots: false,
        arrows: false,
        infinite: true,
        speed: 700,
        adaptiveHeight: false,
        slidesToScroll: 1,
        swipeToSlide: true,
        rows: 0,
        variableWidth: true,
        cssEase: "linear",
      });

      prevBtn.hover(
        function () {
          slider.slick("slickSetOption", "speed", 400, true);
          interval = setInterval(function () {
            slider.slick("slickPrev");
          }, 0);
        },
        function () {
          slider.slick("slickSetOption", "speed", 700, true);
          clearInterval(interval);
        }
      );

      nextBtn.hover(
        function () {
          slider.slick("slickSetOption", "speed", 400, true);
          interval = setInterval(function () {
            slider.slick("slickNext");
          }, 0);
        },
        function () {
          slider.slick("slickSetOption", "speed", 700, true);
          clearInterval(interval);
        }
      );
    });

    $(".icon-slide").hover(
      function () {
        let theIdx = $(this).data("idx");
        $(this)
          .closest(".icon-ribbon-block")
          .find('.icon-caption[data-idx="' + theIdx + '"]')
          .addClass("active");
      },
      function () {
        $(".icon-caption").removeClass("active");
      }
    );

    $("body").on("click", ".ajax-link-wrap a", function (e) {
      e.preventDefault();

      let target = $(this).attr("href");
      let holderSelector = ".ajax-holder";
      let buttonWrap = $(this).closest(".ajax-link-wrap");

      buttonWrap.addClass("please-wait").append('<span class="ajax-spinner"></span>');

      $.get(target, function (data) {
        let dataButton = $(data).find(".ajax-link-wrap");
        data = $(data).find(holderSelector).html();
        //$(data).hide().appendTo(holderSelector).fadeIn(800);
        $(data).addClass("animate-up").appendTo(holderSelector);
        buttonWrap.remove();
        if (dataButton.length) {
          $(dataButton).insertAfter(holderSelector);
        }
      });
    });

    // Toggle resource filters
    $(".resource-filters .the-filter ul.parent-links > li .the-link").on("click", function (e) {
      e.preventDefault();
      $(this).toggleClass("active");
      $(this).next().slideToggle();
    });

    // Toggle resource filters - Mobile
    $(".resource-filters .the-filter .filter-title").on("click", function (e) {
      e.preventDefault();
      $(this).toggleClass("active");
      $(this).next().slideToggle();
    });

    // Find a Representative
    // =============================================
    // Trigger next by pressing Enter
    $(window).keydown(function (event) {
      if ($("body.page-template-find-a-representative").length == 0) {
        return;
      }

      if (event.keyCode === 13) {
        // Enter
        $(".trx_mscf_active .trx_mscf_next, .trx_mscf_active input[type=submit]").trigger("click");
      }
    });

    $(".page-template-find-a-representative .content-column").on("wpcf7mailsent", function (event) {
      $(".page-template-find-a-representative .content-column .wpcf7-form.sent").hide();
      $("#find-rep-results").show();

      var collInputs = event.detail.inputs;
      var address = "";
      var field = "";
      var inputs = {};

      for (var i = 0; i < collInputs.length; i++) {
        inputs[collInputs[i].name] = collInputs[i].value;
      }

      if (inputs.location == "United States + Territories") {
        address = inputs.zip;
        field = "zipcode";
      } else {
        if (inputs.country == "Canada") {
          if (inputs["canada-province"] == "Ontario") {
            address = inputs["canada-postal-code"];
            field = "canada_post_code";
          } else {
            address = inputs["canada-province"];
            field = "canada_province";
          }
        } else {
          address = inputs.country;
          field = "country";
        }
      }

      var ajaxData = {
        action: "repr_search",
        nonce: ajax_var.nonce,
        address: address,
        field: field,
        firstName: inputs["your-name"],
        lastName: inputs["your-lname"],
        yourEmail: inputs["your-email"],
        yourPhone: inputs["your-tel"],
        location: inputs["location"],
        zip: inputs["zip"],
        country: inputs["country"],
        canadaProvince: inputs["canada-province"],
        wetSpaces: inputs["wet-spaces"],
      };

      jQuery.ajax({
        type: "post",
        url: ajax_var.url,
        data: ajaxData,
        success: function (results) {
          $("#find-rep-results .results-wrap").empty().html(results);
        },
      });
    });

    $(".page-template-find-a-representative .content-column").on("click", ".start-over", function () {
      location.reload(true);
    });

    // Advance form to step 2 if Location field was set via GET (i.e., user used the form in the footer)
    // The "Contact Form 7 Multi-Step Addon" plugin doesn't fire an event when it's ready,
    // so wait until the 'trx_mscf_active' class exists before trying to click the next button
    if ($(".page-template-find-a-representative").length && $('select[name="location"]').prop("selectedIndex") !== 0) {
      var checkFindRepReady = setInterval(function () {
        if ($(".trx_mscf_active").length) {
          $("#next1").trigger("click");
          clearInterval(checkFindRepReady);
        }
      }, 100); // check every 100ms
    }

    // Portfolio Filter
    // =============================================
    $(document).on("click", function (e) {
      if ($(e.target).closest(".accordion-item-dropdown").length == 0) {
        $("#accordion-tax-filter").collapse("hide");
      }
    });

    var filterTimeout;
    $("#accordion-tax-filter input").on("change", function () {
      clearTimeout(filterTimeout);
      filterTimeout = setTimeout(function () {
        $(".pff-taxs").submit();
      }, 1000);
    });

    $('.pff-search input[type="search"]').bind("mouseup", function (e) {
      var $input = $(this),
        oldValue = $input.val();
      if (oldValue == "") return;

      setTimeout(function () {
        var newValue = $input.val();
        if (newValue == "") {
          $(".pff-search").submit();
        }
      }, 1);
    });

    $(".portfolio-filter-form").on("submit", function () {
      if ($(this).hasClass("pff-taxs")) {
        $(".pff-search")[0].reset();
      } else {
        $(".pff-taxs")[0].reset();
      }

      const param = $.param({
        action: "portf_filters",
        nonce: ajax_var.nonce,
      });
      const serializedData = $(this).serialize();
      const filterData = param + "&" + serializedData;

      $("#portfolio-data").addClass("please-wait").append('<span class="ajax-spinner"></span>');

      $(".portfolio-filters-section .selected-portfolio-filters").html();
      var selectedFiltersHtml = "";
      $("ul.list-tax-filter li input[type=checkbox]").each(function (index, element) {
        if ($(element).is(":checked")) {
          //console.log($(element).next().text());
          selectedFiltersHtml += `<li>
      <a href="#" title="delete filter" data-filter="${$(element).val()}">
        ${$(element).next().text()} <span>x</span>
      </a>
    </li>`;
        }
      });
      $(".portfolio-filters-section .selected-portfolio-filters").html(selectedFiltersHtml);

      jQuery.ajax({
        type: "get",
        url: ajax_var.url,
        data: filterData,
        success: function (response) {
          $("#portfolio-data").empty().html(response);
          $("#portfolio-data").removeClass("please-wait");
          // Response had results, show "Back to all results" button
          if ($("#portfolio-data .portfolio-block .the-carousel").length) {
            $(".back-to-all").show();
          } else {
            $(".back-to-all").hide();
          }
          /* $("#portfolio-data .portfolio-block .the-carousel").each(function () {
            var slider = $(this);
            var prevBtn = $(this).parent().find(".prev");
            var nextBtn = $(this).parent().find(".next");

            if ($("body").hasClass("page-template-portfolio-landing")) {
              var counterElement = $(".pagination-links--portfolio-landing .page-numbers .count");
              $(".pagination-links").addClass("filters-applied");
            } else {
              var counterElement = $(this).parent().find(".carousel-nav .page-numbers .count");
              $(".pagination-links").removeClass("filters-applied");
            }

            slider.on("init reInit afterChange", function (event, slick, currentSlide, nextSlide) {
              var i = (currentSlide ? currentSlide : 0) + 1;
              counterElement.text(leftFillNum(i, 2) + "/" + leftFillNum(slick.slideCount, 2));
            });
            slider.slick({
              autoplay: false,
              autoplaySpeed: 3000,
              dots: false,
              arrows: true,
              infinite: true,
              speed: 700,
              slidesToShow: 1,
              slidesToScroll: 1,
              adaptiveHeight: false,
              rows: 0,
              prevArrow: prevBtn,
              nextArrow: nextBtn,
            });
          }); */

          $(".portfolio-block .the-carousel.carousel-xl").each(function (index, element) {
            var slider = $(this);
            var counterElement;

            if ($("body").hasClass("page-template-portfolio-landing")) {
              counterElement = $(".pagination-links--portfolio-landing.pagination-links--xl .page-numbers .count");
              var prevBtn = $(this).parent().parent().find(".pagination-links--xl .prev");
              var nextBtn = $(this).parent().parent().find(".pagination-links--xl .next");
            } else {
              counterElement = $(this).parent().find(".carousel-nav .page-numbers .count");
              var prevBtn = $(this).parent().find(".prev");
              var nextBtn = $(this).parent().find(".next");
            }

            slider.on("init reInit afterChange", function (event, slick, currentSlide, nextSlide) {
              var i = (currentSlide ? currentSlide : 0) + 1;
              counterElement.text(leftFillNum(i, 2) + "/" + leftFillNum(slick.slideCount, 2));
            });
            slider.slick({
              autoplay: false,
              autoplaySpeed: 3000,
              dots: false,
              arrows: true,
              infinite: true,
              speed: 700,
              slidesToShow: 1,
              slidesToScroll: 1,
              adaptiveHeight: false,
              rows: 0,
              prevArrow: prevBtn,
              nextArrow: nextBtn,
            });
          });

          $(".portfolio-block .the-carousel.carousel-sm").each(function (index, element) {
            var slider = $(this);
            var counterElement;

            if ($("body").hasClass("page-template-portfolio-landing")) {
              counterElement = $(".pagination-links--portfolio-landing.pagination-links--sm .page-numbers .count");
              var prevBtn = $(this).parent().parent().find(".pagination-links--sm .prev");
              var nextBtn = $(this).parent().parent().find(".pagination-links--sm .next");
            } else {
              counterElement = $(this).parent().find(".carousel-nav .page-numbers .count");
              var prevBtn = $(this).parent().find(".prev");
              var nextBtn = $(this).parent().find(".next");
            }

            slider.on("init reInit afterChange", function (event, slick, currentSlide, nextSlide) {
              var i = (currentSlide ? currentSlide : 0) + 1;
              counterElement.text(leftFillNum(i, 2) + "/" + leftFillNum(slick.slideCount, 2));
            });
            slider.slick({
              autoplay: false,
              autoplaySpeed: 3000,
              dots: false,
              arrows: true,
              infinite: true,
              speed: 700,
              slidesToShow: 1,
              slidesToScroll: 1,
              adaptiveHeight: false,
              rows: 0,
              prevArrow: prevBtn,
              nextArrow: nextBtn,
            });
          });

          /* $(".hero-images-slider").slick("unslick");
          $(".basic-gallery-caption-slider").slick("unslick"); */
          heroSliderInit();
		  		 
		  window.history.pushState('', '', '?' + decodeURI(serializedData));
        },
      });

      return false;
    });

    // Delete portfolio filter on top when clicked
    $(document).on("click", "ul.selected-portfolio-filters li a", function (e) {
      e.preventDefault();
      var product_category = $(this).data("filter");
      $(this).parent().remove();
      $(document).find(`ul.list-tax-filter li input[type=checkbox][value=${product_category}]`).trigger("click");
    });

    // Toggle 3d detail box
    $(".threed__blocks").each(function (index, element) {
      var $grid = $(this).isotope({
        itemSelector: ".threed__blocks .threed__item",
        layoutMode: 'packery',
        sortBy: "clickedFirst",
        getSortData: {
          clickedFirst: function (itemElem) {
            var $item = $(itemElem);
            // expanded first, otherwise use index
            return $item.hasClass("is-expanded") ? -1 : $item.index();
          },
        },
      });

      $grid.on("click", ".threed__item .item__thumb, .threed__item .item__name-wrapper .btn--view", function (e) {
        e.preventDefault();
        var $grid = $(this).closest(".threed__blocks");
        var $this = $(this).closest(".threed__item");
				var expandedItemHeight = 0;
				
				// Reset min-heights 
				$grid.find(".threed__item-inner").css('min-height','');
        
        // Toggle other expanded
        if (!$this.hasClass("is-expanded")) {
          $grid.find(".is-expanded").removeClass("is-expanded");
        }
        
        // Change size of item by toggling is-expanded class
        $this.toggleClass("is-expanded");
        
        // Enable embed code
        var embed_code = $this.find(".embed_code").val();
        if (embed_code !== "") {
          $this.find(".item__embed").html(embed_code);
        }
				
				var expandedItem = $grid.find(".threed__item.is-expanded");
				var unexpandedItems = $grid.find(".threed__item:not(.is-expanded)");
				
				// User has expanded an item
        if (expandedItem.length) {
          $grid.addClass("expanded");
					
					// Get expanded item height
					var expandedItemHeight = expandedItem.height();
					
					// Get non-expanded items total height
					var nonexpandedItemsHeight = 0;
					unexpandedItems.each(function(){
						nonexpandedItemsHeight += $(this).height();
					});
					
					// Expanded is TALLER than non-expanded, make non-expanded total height match expanded
					if( expandedItemHeight > nonexpandedItemsHeight ){
						var targetHeight = expandedItemHeight/2 - parseInt($('.threed__item-inner', unexpandedItems).first().css('margin-bottom'));
						$('.threed__item-inner', unexpandedItems).css('min-height', targetHeight);
						
					// Expanded is SHORTER than non-expanded, make expanded height match non-expanded total height
					} else if( expandedItemHeight < nonexpandedItemsHeight ) {
						var targetHeight = nonexpandedItemsHeight - parseInt($('.threed__item-inner', unexpandedItems).first().css('margin-bottom'));
						$('.threed__item-inner', expandedItem).css('min-height', targetHeight);
						
					}
				
				// User has toggled off the expanded item
        } else {
          $grid.removeClass("expanded");
					$grid.find(".threed__item-inner").css('min-height',''); // reset min-heights
        }

        // update sort data, sort, and layout
        $grid.isotope("updateSortData").isotope();
      });

      $grid.on("click", ".threed__item .btn--close", function (e) {
        e.preventDefault();
        var $this = $(this).closest(".threed__item");
        $this.find(".item__embed").html("");

        $grid.find(".is-expanded").removeClass("is-expanded");
        $grid.removeClass("expanded");
				
				$grid.find(".threed__item-inner").css('min-height','');

        // update sort data, sort, and layout
        $grid.isotope("updateSortData").isotope();
      });
    });

    // Timeline scroller
    $(".timeline__line-component").each(function (index, element) {
      var controller = new ScrollMagic.Controller();
      var rainbowGradient = chroma.scale(["#1F0081", "#04E1CA", "#15B913", "#FFFB00", "#FA2B2B"]);
      var timeline_height = $(".timeline-events .timeline__line-component_" + index).height();
      var scene = new ScrollMagic.Scene({ triggerElement: ".timeline-events .timeline__line-component_" + index + " .timeline__trigger", duration: timeline_height }).setPin(".timeline-events .timeline__line-component_" + index + " .timeline__pin").addTo(controller);

      scene.on("progress", function (ev) {
        $(".timeline-events .timeline__line-component_" + index + " .timeline-dot .dot").css("background", rainbowGradient(ev.progress).css());
      });
    });
		
		function toggleTimelineDotGrow() {
			var windowHeight = $(window).height();

			$('.timeline-events .event-date').each(function() {
				var elementTop = $(this)[0].getBoundingClientRect().top,
						visibleOffset = (windowHeight / 2) - 150,
						hideOffset = (windowHeight / 2) + 150;
				
				// If element is in center of viewport, make event active
				if (elementTop >= visibleOffset && elementTop <= hideOffset) {
					$(this).closest('.timeline-events').addClass('event-active');
					return false;
				} else {
					$(this).closest('.timeline-events').removeClass('event-active');
				}
			});
		}
		toggleTimelineDotGrow();
		$(window).on('scroll load', function(){
			toggleTimelineDotGrow();
		});
		
		function halfScrollSlides() {
			var windowHeight = $(window).height();

			$('.half-scroll-slide-show .content-block').each(function(index) {
				
				console.log('=================================');
				console.log('testing item ' + index);
				
				var elementTop = $(this)[0].getBoundingClientRect().top,
				    elementBottom = $(this)[0].getBoundingClientRect().bottom,
						viewportMiddle = windowHeight / 2 + 100,
						slideshow = $(this).closest('.half-scroll-slide-show');
				
				console.log('elementTop: ' + elementTop);
				console.log('elementBottom: ' + elementBottom);
				console.log('viewportMiddle: ' + viewportMiddle);

				// If element top is above the middle of the viewport, and bottom is below middle of viewport
				if (elementTop <= viewportMiddle && elementBottom >= viewportMiddle) {
					console.log('element ' + index + ' is visible!')
					slideshow.find('.the-images img').eq(index).addClass('active');
				} else {
					console.log('element ' + index + ' is NOT visible!')
					slideshow.find('.the-images img').eq(index).removeClass('active');
				}
			});
		}
		halfScrollSlides();
		$(window).on('scroll load', function(){
			halfScrollSlides();
		});
		
  }); // END On Dom Ready
})(jQuery);

// Add leading zero to number
function leftFillNum(num, targetLength) {
  return num.toString().padStart(targetLength, 0);
}
